var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3323_25888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9989 11.6616C27.029 14.9827 25.8375 17.5986 24.2147 20.0306C23.0695 21.7501 21.8177 23.3965 20.5936 25.0619C19.3464 26.7602 18.1456 28.4868 17.1441 30.3503C16.8103 30.9706 16.4139 31.3763 15.941 30.4753C14.0794 26.9277 11.5062 23.8777 9.29 20.5754C7.62784 18.0963 6.16736 15.5253 6.01436 12.4117C5.74081 6.81188 9.40128 2.11789 14.8027 1.15314C19.8611 0.249723 24.8453 3.4223 26.5005 8.58805C26.8552 9.68489 27.0151 10.8006 26.9989 11.6616Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3323_25888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85319 12.6233C6.99395 15.5536 8.33759 17.9733 9.86679 20.3064C10.5496 21.3472 11.2692 22.3613 11.9887 23.3753C13.2045 25.0886 14.42 26.8016 15.4572 28.6421C15.4595 28.6462 15.4618 28.6504 15.4642 28.6545C15.6437 28.9734 15.8178 29.2962 15.9857 29.6234C16.4208 30.4714 16.7855 30.0896 17.0926 29.5058C17.2115 29.2794 17.3334 29.0553 17.4581 28.833C17.4582 28.8329 17.4581 28.8331 17.4581 28.833C17.4882 28.7795 17.5185 28.7258 17.5489 28.6725C17.5536 28.6643 17.5582 28.6561 17.5629 28.6478C18.3796 27.2166 19.308 25.8633 20.2661 24.5287C20.4985 24.2054 20.7319 23.8828 20.9653 23.5603C21.8632 22.3192 22.7613 21.0781 23.5975 19.7936C25.0905 17.5049 26.1867 15.043 26.159 11.9173C26.1739 11.1071 26.0267 10.057 25.7004 9.02477C24.1776 4.16315 19.5922 1.17736 14.9385 2.02758C9.96916 2.93553 6.60152 7.35317 6.85319 12.6233ZM27.4518 8.44748C25.6714 2.76821 20.2522 -0.855258 14.615 0.174653C8.70276 1.25488 4.72016 6.5329 5.01538 12.7151C5.18242 16.1924 6.78195 18.9797 8.3385 21.3546C9.03968 22.4234 9.79543 23.4887 10.5265 24.5191C10.8761 25.0118 11.22 25.4966 11.5499 25.9704C12.5955 27.472 13.5584 28.9423 14.3564 30.498C14.5197 30.8163 14.7846 31.2465 15.2186 31.5685C15.7456 31.9596 16.4531 32.1302 17.1666 31.888C17.7419 31.6927 18.1004 31.2991 18.2721 31.0857C18.4658 30.8449 18.6116 30.5902 18.7129 30.3977C19.5718 28.7628 20.6155 27.2221 21.7492 25.6428C21.9731 25.3312 22.2008 25.0165 22.4306 24.6989C23.3313 23.4543 24.2641 22.1652 25.1281 20.8383M27.4518 8.44748C27.8301 9.64489 28.0146 10.8906 27.9991 11.9256C28.0252 15.5534 26.7323 18.3788 25.1281 20.8383M17.634 28.7826C17.634 28.7829 17.6308 28.7782 17.6248 28.7674C17.6311 28.7768 17.6341 28.7822 17.634 28.7826Z",
    fill: "#799700"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3323_25888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3323_25888",
    x: 4,
    y: 1,
    width: 25,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3323_25888",
    x: 3,
    y: 0,
    width: 27,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3323_25888",
    x: 7,
    y: 4,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25888",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.addf35eccf76b53cf4adf4cc2b791fc1.svg";
export { ForwardRef as ReactComponent };